import Question from '@/orm/models/Test/Question';

export default function useQuestion() {
  async function createQuestion(id, testId, payload) {
    return Question.api().createQuestion(id, testId, payload);
  }

  async function updateQuestion(id, testQuestionId, payload) {
    return Question.api().updateQuestion(id, testQuestionId, payload);
  }

  async function deleteQuestion(id, testQuestionId) {
    await Question.api().deleteQuestion(id, testQuestionId);
    await Question.delete(testQuestionId);
  }

  async function uploadQuestionImage(testQuestionId, payload) {
    return Question.api().uploadQuestionImage(testQuestionId, payload);
  }

  async function deleteQuestionImage(testQuestionId) {
    await Question.api().deleteQuestionImage(testQuestionId);
  }

  return {
    createQuestion,
    updateQuestion,
    deleteQuestion,
    uploadQuestionImage,
    deleteQuestionImage,
  };
}
